(function () {
  var grids = Array.prototype.slice.call(
    document.querySelectorAll('.front-participants__grid')
  );

  if (!grids.length || window.matchMedia('(pointer: coarse)').matches) return;

  var cards = Array.prototype.slice.call(
    document.querySelectorAll('.front-participants__card')
  );
  var pointerX = 0;
  var pointerY = 0;
  var pointerFrame;

  var updateShimmer = function () {
    cards.forEach(function (card) {
      var bounds = card.getBoundingClientRect();
      var localX = pointerX - bounds.left;
      var localY = pointerY - bounds.top;
      var outsideX = Math.max(-localX, 0, localX - bounds.width);
      var outsideY = Math.max(-localY, 0, localY - bounds.height);
      var distance = Math.sqrt(outsideX * outsideX + outsideY * outsideY);
      var opacity = Math.max(0, 1 - distance / 240);

      card.style.setProperty('--participant-shimmer-x', localX + 'px');
      card.style.setProperty('--participant-shimmer-y', localY + 'px');
      card.style.setProperty('--participant-shimmer-opacity', opacity);
    });

    pointerFrame = null;
  };

  grids.forEach(function (grid) {
    grid.addEventListener('pointermove', function (event) {
      pointerX = event.clientX;
      pointerY = event.clientY;

      if (!pointerFrame) {
        pointerFrame = window.requestAnimationFrame(updateShimmer);
      }
    });

    grid.addEventListener('pointerleave', function () {
      window.cancelAnimationFrame(pointerFrame);
      pointerFrame = null;

      cards.forEach(function (card) {
        card.style.setProperty('--participant-shimmer-opacity', 0);
      });
    });
  });
})();
